import(/* webpackMode: "eager" */ "/vercel/path0/components/UI/BriefIntroduction/BriefIntroduction.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/UI/Skills/Skills.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
